<h2 mat-dialog-title [ngClass]="{ pink: data?.isPinkTitle }">
  {{ data?.title }}
</h2>
@if (isPrimaryMessage()) {
  <mat-dialog-content>
    {{ data?.message }}
  </mat-dialog-content>
  <mat-dialog-actions class="dialog-actions" align="end">
    <button class="dark-button" (click)="showNewMessage()" id="dialog-confirm-changed-close-button">
      {{ data.cancelBtnText || 'Close' }}
    </button>
    <button class="dashboard-btn" [mat-dialog-close]="false" id="dialog-confirm-changed-confirm-button">
      {{ data.confirmBtnText || 'Confirm' }}
    </button>
  </mat-dialog-actions>
}

@if (!isPrimaryMessage()) {
  <mat-dialog-content>
    <div class="container">
      <img src="assets/images/jtv_logout_mini.png" alt="Uber Logout" />
    </div>
    <div class="container">Redirecting in {{ remainingTime }} seconds</div>
  </mat-dialog-content>
  <mat-dialog-actions class="dialog-actions" align="end">
    <button class="dashboard-btn" (click)="closeDialog()" id="dialog-confirm-changed-ok-button">
      Ok, got it
    </button>
  </mat-dialog-actions>
}
